module.exports = __webpack_public_path__ + "static/img/grid1.8eeb659.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid1.png
// module id = CcZd
// module chunks = 0